import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBps, FctValue18 } from '../../../../Fct/generics';
import { LENDING_POOL_ADDRESSES } from '../constants';
export var GetUserAccountData = createPlugin({
    protocol: 'RADIANTV2',
    type: 'GETTER',
    method: 'getUserAccountData',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'radiant_lending_pool_v2' }),
            methodParams: {
                user: new FctAddress({}),
            },
        },
        output: {
            totalCollateralETH: new FctValue18({ innerIndex: 0 }),
            totalDebtETH: new FctValue18({ innerIndex: 1 }),
            availableBorrowsETH: new FctValue18({ innerIndex: 2 }),
            currentLiquidationThreshold: new FctBps({ innerIndex: 3 }),
            ltv: new FctBps({ innerIndex: 4 }),
            healthFactor: new FctValue18({ innerIndex: 5 }),
        },
    }); },
});
